import { createContext, useContext } from 'react';

import type { CrmCustomerRecordContextResponse } from '@features/crm-customer-record-context';
import {
  firstAccessibleCrmCustomerRecordArea,
  type DeliveredCrmCustomerRecordArea,
} from './customer-record-areas';

type ReadyContext = CrmCustomerRecordContextResponse['data'] & {
  customer: NonNullable<CrmCustomerRecordContextResponse['data']['customer']>;
};

export interface CrmCustomerRecordValue extends ReadyContext {
  canAccessArea: (area: DeliveredCrmCustomerRecordArea['id']) => boolean;
  refreshAuthorization: () => Promise<void>;
  viewerAccessScope: string;
}

export const CrmCustomerRecordContext = createContext<CrmCustomerRecordValue | null>(null);

export function useCrmCustomerRecord() {
  const customer = useContext(CrmCustomerRecordContext);
  if (!customer) throw new Error('useCrmCustomerRecord must be used within CrmCustomerRecordShell');
  return customer;
}

export function useCrmCustomerRecordRouteGuard(area: DeliveredCrmCustomerRecordArea['id']) {
  const context = useCrmCustomerRecord();
  return context.canAccessArea(area)
    ? null
    : firstAccessibleCrmCustomerRecordArea(context.allowedAreas);
}
